import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk';
import makeRootReducer from './reducers';
import Routes from 'Routes';
import axiosMiddleware from './axiosMiddleware';

export default (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk, axiosMiddleware];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];

  let composeEnhancers = compose;

  if (process.env.NODE_ENV !== 'production') {
    const composeWithDevToolsExtension =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================

  const persistConfig = {
    key: 'emp',
    version: 1,
    storage,
    whitelist: [
      'App',
      'updateDetail',
      'EdorsedApply',
      'selectDate',
      'ticketChange',
      'applySubmit',
      // 'addPersonMessage',
      // 'subInfo',
      'addProductShop',
      'realNameVerify',
      'feeQuery',
      'changeFlight',
      'easyLoginQuery',
      'coupons',
      'refundCoupons',
      'cancelLation',
    ],
    stateReconciler: function(inboundState, originalState, reducedState) {
      if (
        window.location.href.indexOf(Routes.ticket.child.endorsedApply.path) !==
        -1
      ) {
        return Object.assign({}, reducedState, {
          _persist: {
            version: 1,
            rehydrated: true,
          },
        });
      }
      return inboundState;
    },
  };

  const persistedReducer = persistReducer(persistConfig, makeRootReducer());

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  );
  store.asyncReducers = {};

  const persistor = persistStore(store);

  if (/(loginFeeQuery)|(feeQuery)/.test(window.location.href)) {
    persistor.pause();
  }

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return {
    store,
    persistor,
  };
};



// WEBPACK FOOTER //
// ./src/store/createStore.js